import { AfterViewInit, Component } from "@angular/core";
import { CatalogService } from "../../services/catalog.service";
import { Catalog, Page, Element } from "@app/data/catalog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Listing } from "@app/data/listing";

import { ListingCartItem, Customer } from "shopping/cart";
import { DigitalOrderSheet } from "@app/data/digital-order-sheet";
import { DigitalOrderSheetService } from "@app/services/digital-order-sheet.service";
import { CartService } from "shopping/cart.service";

@Component({
  templateUrl: "./shopping-cart.component.html",
})
export class ShoppingCartComponent implements AfterViewInit {
  digitalOrderSheet: DigitalOrderSheet;
  isFromCatalog: boolean;
  id: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cartService: CartService<ListingCartItem>,
    private digitalOrderSheetService: DigitalOrderSheetService
  ) {
    this.id = this.route.snapshot.params["id"];

    this.route.data.subscribe((data) => {
      let source = data.source;
      if (source === "catalog") {
        this.isFromCatalog = true;
      } else if (source === "online store") {
        this.isFromCatalog = false;
        this.digitalOrderSheetService.get(this.id).then((digitalOrderSheet) => {
          this.digitalOrderSheet = digitalOrderSheet;
          this.cartService.setTaxRate(this.digitalOrderSheet.default_tax || 0);
        });
      }
    });
  }

  ngAfterViewInit(): void {}

  emptyCart() {
    this.cartService.clear();
  }

  openOrderSheet() {
    if (this.isFromCatalog) {
      this.router.navigate([`/catalogs/${this.id}/order-sheet/view`]);
    } else {
      this.router.navigate([`/digital-order-sheets/${this.id}/view`]);
    }
  }

  openOrderCompletion() {
    if (this.isFromCatalog) {
      this.router.navigate([`/catalogs/${this.id}/order-sheet/complete-order`]);
    } else {
      this.router.navigate([`/digital-order-sheets/${this.id}/complete-order`]);
    }
  }
}
